import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import {
	CashPlusConfigurationsApi,
	CashPlusPortfolioApi,
	CashPlusSubscriptionsApi,
	isFundReleasedInterface,
	OptStatus
} from "@modules/cashplus/entities/cashplus.model";
import { parseApiResponseObject2 } from "@helpers/functions";
import { map } from "rxjs/operators";
import { FiatTransaction } from "@models/transaction";

@Injectable({ providedIn: "root" })
export class CashPlusRemote {
	constructor(private apicallService: ApicallService) {}

	public updateOptStatus$(status: string): Observable<unknown> {
		return this.apicallService.put("earn-on-fiat/subscriptions/" + status);
	}

	public optOut$(): Observable<unknown> {
		return this.apicallService.put("earn-on-fiat/subscriptions/" + OptStatus.OptOut, new ApicallOption(), true);
	}

	public getSubscriptions$(): Observable<CashPlusSubscriptionsApi> {
		return this.apicallService
			.get("earn-on-fiat/subscriptions")
			.pipe(
				map((response: CashPlusSubscriptionsApi) => parseApiResponseObject2<CashPlusSubscriptionsApi>(response))
			);
	}

	public getConfigurations$(): Observable<CashPlusConfigurationsApi> {
		return this.apicallService
			.get("earn-on-fiat/configurations")
			.pipe(
				map((response: CashPlusConfigurationsApi) =>
					parseApiResponseObject2<CashPlusConfigurationsApi>(response)
				)
			);
	}

	public getPortfolioAssetFiats$(fiatPid: string): Observable<CashPlusPortfolioApi> {
		return this.apicallService
			.get(`portfolio/asset/fiats/${fiatPid}`)
			.pipe(map((response: CashPlusPortfolioApi) => parseApiResponseObject2<CashPlusPortfolioApi>(response)));
	}

	public freeUpCash$(fiatPid: string): Observable<isFundReleasedInterface> {
		return this.apicallService
			.post(`earn-on-fiat/fiats/${fiatPid}/funds/release`, new ApicallOption())
			.pipe(
				map((response: isFundReleasedInterface) => parseApiResponseObject2<isFundReleasedInterface>(response))
			);
	}

	public getReleased$(fiatPid: string): Observable<isFundReleasedInterface> {
		return this.apicallService
			.get(`earn-on-fiat/fiats/${fiatPid}/funds/release`)
			.pipe(
				map((response: isFundReleasedInterface) => parseApiResponseObject2<isFundReleasedInterface>(response))
			);
	}

	public getFiatWalletTransactions(walletId: string): Observable<FiatTransaction[]> {
		return this.apicallService
			.get(`fiatwallet/${walletId}/transactions`)
			.pipe(map((res) => res as FiatTransaction[]));
	}
}
